<template>
  <div class="flex gap-4">
    <input
      :value="start"
      v-maska
      data-maska="##:##"
      @maska="handleStartTime"
      @blur="handleStartTimeBlur"
      placeholder="09:15"
      type="text"
      :disabled="props.disabled"
      class="block w-full rounded-sm border-gray-300 focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
      :class="{ 'opacity-60 !cursor-not-allowed select-none': disabled }"
    />
    <input
      :value="end"
      v-maska
      data-maska="##:##"
      @maska="handleEndTime"
      @blur="handleEndTimeBlur"
      placeholder="14:30"
      type="text"
      :disabled="props.disabled"
      class="block w-full rounded-sm border-gray-300 focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
      :class="{ 'opacity-60 !cursor-not-allowed select-none': disabled }"
    />
  </div>
</template>

<script setup>
import { vMaska } from "maska";
import { ref } from "vue";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const start = ref();
const end = ref();

const handleStartTimeBlur = () => {
  let [hours, minutes] = start.value.split(":");
  if (!hours) {
    return;
  }

  if (!minutes) {
    start.value = `${hours}:00`;
  }
};

const handleEndTimeBlur = () => {
  let [hours, minutes] = end.value.split(":");
  if (!hours) {
    return;
  }

  if (!minutes) {
    end.value = `${hours}:00`;
  }
};

const handleStartTime = (e) => {
  const { masked } = e.detail;
  let [hours, minutes] = masked.split(":");

  if (!minutes) {
    if (hours > 23) {
      hours = 23;
    }

    start.value = `${hours}`;
  }

  if (minutes) {
    if (minutes > 59) {
      minutes = 59;
    }

    start.value = `${hours}:${minutes}`;
  }

  emit("update:modelValue", {
    start: start.value,
    end: end.value,
  });
};

const handleEndTime = (e) => {
  const { masked } = e.detail;
  let [hours, minutes] = masked.split(":");

  if (!minutes) {
    if (hours > 23) {
      hours = 23;
    }

    end.value = `${hours}`;
  }

  if (minutes) {
    if (minutes > 59) {
      minutes = 59;
    }

    end.value = `${hours}:${minutes}`;
  }

  emit("update:modelValue", {
    start: start.value,
    end: end.value,
  });
};
</script>
